import React from 'react';
import './BackButton.css';
import { useNavigation } from '../../contexts/NavigationContext';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Shared BackButton Component
 * Icon-only chevron used on detail and sub-pages to navigate back.
 *
 * @param {Function} onClick   - Click handler (optional; falls back to navigation.onNavigateBack)
 * @param {String}   ariaLabel - Accessible label (optional; defaults to t('back'))
 * @param {String}   className - Extra class for layout overrides (optional)
 */
const BackButton = ({ onClick, ariaLabel, className }) => {
  const navigation = useNavigation();
  const { t } = useLanguage();
  const handleClick = onClick || navigation.onNavigateBack;
  return (
    <button
      type="button"
      className={`shared-back-button${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={ariaLabel || t('back') || 'Zurück'}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default BackButton;
